import { MentorshipNavigationItem } from '../common/navigation';

export const MENTOR_NAVIGATION: MentorshipNavigationItem[] = [
  { key: 'profile', label: 'My Profile', icon: 'mentor' },
  { key: 'dashboard', label: 'Dashboard' },
  { key: 'workspace', label: 'Workspace' },
  { key: 'programs', label: 'Programs' },
  { key: 'mentees', label: 'Mentees' },
  { key: 'chat', label: 'Chat' },
  { key: 'resources', label: 'Resource' },
  { key: 'notifications', label: 'Notifications' },
];
